module.exports = __webpack_public_path__ + "img/hifu_img.79e6927b.png";